import { render, staticRenderFns } from "./cog.vue?vue&type=template&id=2bcaacd3&"
import script from "./cog.vue?vue&type=script&lang=js&"
export * from "./cog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports